import React from 'react';
import _ from 'underscore';

import {ProtocolSection, FromServerProtocol} from 'notebook/ELNConstants';
// @ts-expect-error
import formatters from 'notebook/mediocre/formatted-text/formatters';
import * as parseutil from 'notebook/protocols/ParseUtil';
import * as ProtocolUtil from 'notebook/protocols/ProtocolUtil';
import Commentable from 'notebook/protocols/viewer/Commentable';
// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import Comments from 'notebook/protocols/viewer/Comments';
import MaterialsList from 'notebook/protocols/viewer/MaterialsList';
import ProtocolProcedureContainer from 'notebook/protocols/viewer/ProtocolProcedureContainer';
import Section from 'notebook/protocols/viewer/Section';

interface Props {
  commentBus?: CommentBus;
  protocol: FromServerProtocol;
  sections: Array<ProtocolSection>;
  showTitle: boolean;
  showFormulaBox: boolean;
}

class Viewer extends React.Component<Props> {
  render(): JSX.Element {
    const replies = this.props.protocol.comments.filter((comment) => comment.type === 'comment');
    const {protocol} = this.props;
    return (
      <div className="protocol-viewer">
        {this.props.showTitle ? <h1>{ProtocolUtil.displayName(protocol)}</h1> : undefined}
        {(() => {
          const result = [];
          for (const section of Array.from(this.props.sections)) {
            switch (section.key) {
              case 'intro':
                if (protocol.description != null ? protocol.description.trim() : undefined) {
                  result.push(
                    <Section title="Introduction" key={`intro-${protocol.id}`} navID="intro">
                      <Commentable
                        linkableID={protocol.id}
                        // TODO(eln): this should be protocol_version
                        linkType="protocol"
                        onDescription={true}
                        commentBus={this.props.commentBus}
                        commentReplies={replies}
                        // eslint-disable-next-line no-restricted-syntax
                        comments={_.filter(
                          protocol.comments,
                          (comment) => comment.type === 'protocol' && comment.on_description
                        )}
                      >
                        <div
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: formatters.renderHTML(protocol.description, protocol.descriptionFormats, {
                              paragraphMode: true,
                              processText: parseutil.parseHTML,
                            }),
                          }}
                        />
                      </Commentable>
                    </Section>
                  );
                } else {
                  result.push(undefined);
                }
                break;
              case 'materials':
                result.push(
                  <Section title="Materials" key={`materials-${protocol.id}`} navID="materials">
                    <MaterialsList
                      materials={protocol.materials}
                      commentBus={this.props.commentBus}
                      commentReplies={replies}
                      // eslint-disable-next-line no-restricted-syntax
                      comments={_.filter(protocol.comments, (comment) => comment.type === 'material')}
                    />
                  </Section>
                );
                break;
              case 'procedure':
                result.push(
                  <Section title="Procedure" key={`procedure-${protocol.id}`} navID="procedure">
                    <ProtocolProcedureContainer
                      selectors={protocol.selectors}
                      steps={protocol.steps}
                      showFormulaBox={this.props.showFormulaBox}
                      commentBus={this.props.commentBus}
                      commentReplies={replies}
                      // eslint-disable-next-line no-restricted-syntax
                      comments={_.filter(protocol.comments, (comment) => comment.type === 'step')}
                      protocol={protocol}
                    />
                  </Section>
                );
                break;
              case 'comments':
                result.push(
                  <Section title="Comments" key={`comments-${protocol.id}`} navID="comments">
                    <Comments
                      commentBus={this.props.commentBus}
                      comments={protocol.comments}
                      protocolID={protocol.id}
                    />
                  </Section>
                );
                break;
              default:
                throw new Error(`Unsupported section: ${section.key}`);
            }
          }
          return result;
        })()}
      </div>
    );
  }
}

export default Viewer;
